import Wrapper from '@views/Components/Wrapper'

import { Fragment, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { generateUrl } from '@services/routes'
import { ROUTE_LOGS_MODE } from '@features/routes'

import Firewall from '@views/Logs/Firewall'
import Nsgflow from '@views/Logs/Nsgflow'

export const Logs = () => {
    const match = useParams()
    const navigate = useNavigate()

    const [selectedPanel, setSelectedPanel] = useState(<Fragment />)

    useEffect(() => {
        if (match.mode === 'firewall') setSelectedPanel(<Firewall />)
        else if (match.mode === 'flow') setSelectedPanel(<Nsgflow />)
        else return navigate(generateUrl(ROUTE_LOGS_MODE, {mode: 'firewall'}))
    }, [match])

    return (
        <Wrapper>
            {selectedPanel}
        </Wrapper>
    )
}

export default Logs